<h1 mat-dialog-content>{{ data['name'] }}</h1>
@if (data?.options?.showCancel || data['showCancel']) {
    <div mat-dialog-content>
        <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
            <button mat-raised-button [mat-dialog-close]="data['name']">Yes</button>
            <button mat-raised-button cdkFocusInitial (click)="onNoClick()">No</button>
        </div>
    </div>
} @else {
    <div mat-dialog-content>
        <button style="width: 100% !important;" mat-button [mat-dialog-close]="data['name']" cdkFocusInitial>Ok</button>
    </div>
}

